import { io } from "socket.io-client";

const baseUrl = process.env.REACT_APP_API_ENDPOINT;

var connectionOptions = {
  "force new connection": true,
  reconnectionAttempts: "Infinity",
  timeout: 10000,
  "transports": ['websocket', 'polling', 'flashsocket']
};

const socket = (token = '', query) => io(baseUrl, {...connectionOptions, ...(token && {auth: {token}}), ...(query && {query})});

export default socket;